import React, { useContext } from "react";
import { Col, Label, Row } from "reactstrap";
import ViewOfferChildTableForTier from "./ViewOfferChildTableForTier";
import {
  formatCellValue,
  formatDateForDisplay,
} from "../../Utils/UtilityFunctions";

const ViewOfferBalanceImpactList = ({ pushRef, value, usageType }) => {
  const tiersColumns = [
    {
      accessorKey: "startingUnit",
      header: "Starting Unit",
      muiTableBodyCellProps: {
        sx: {
          width: "25%",
          borderBottom: "none",
          paddingY: "4px",
          paddingX: "0px",
        },
      },
      Cell: ({ cell }) => formatCellValue(cell.getValue()),
    },
    {
      accessorKey: "endingUnit",
      header: "Ending Unit",
      muiTableBodyCellProps: {
        sx: {
          width: "25%",
          borderBottom: "none",
          paddingY: "4px",
          paddingX: "0px",
        },
      },
      Cell: ({ cell }) => formatCellValue(cell.getValue()),
    },
    {
      accessorKey: "pricePerUnit",
      header: "Price Per Unit",
      muiTableBodyCellProps: {
        sx: {
          width: "25%",
          borderBottom: "none",
          paddingY: "8px",
          paddingX: "0px",
        },
      },
      Cell: ({ cell }) => formatCellValue(cell.getValue()),
    },
    {
      accessorKey: "empty",
      header: "",
      muiTableBodyCellProps: {
        sx: {
          width: "25%",
          borderBottom: "none",
          paddingY: "4px",
          paddingX: "0px",
        },
      },
      Cell: ({ cell }) => formatCellValue(cell.getValue()),
    },
  ];

  return (
    <div className="live-preview">
      {value.length === 0 ? (
        <div className="text-center">No Balance Impact Details</div>
      ) : (
        value?.map((val, index) => {
          // const keyIndex = value?.length - (index + 1);
          const keyIndex = index;

          return (
            <div
              key={index}
              className="border-top border-opacity-50 rounded-0 mb-3"
            >
              <Row className="mt-4">
                <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                  <Label
                    className="fw-bold"
                    for={`balanceImpacts[${keyIndex}].resourceName`}
                  >
                    Resource Name
                  </Label>
                  <p>{val?.resourceName ? val?.resourceName?.label : "-"}</p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                  <Label
                    className="fw-bold"
                    for={`balanceImpacts[${keyIndex}].uom`}
                  >
                    UOM
                  </Label>
                  <p>{val?.uom ? val?.uom?.label : "-"}</p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                  <Label
                    className="fw-bold"
                    for={`balanceImpacts[${keyIndex}].flatRate`}
                  >
                    Flat Rate
                  </Label>
                  <p>{val?.flatRate ? val?.flatRate : "-"}</p>
                </Col>
                {usageType === "2" && (
                  <>
                    <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                      <Label
                        className="fw-bold"
                        for={`balanceImpacts[${keyIndex}].recurringFrequency`}
                      >
                        Recurring Frequency
                      </Label>
                      <p>
                        {val?.recurringFrequency
                          ? val?.recurringFrequency?.label
                          : "-"}
                      </p>
                    </Col>
                    <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                      <Label
                        className="fw-bold"
                        for={`balanceImpacts[${keyIndex}].recurringFrequencyUnit`}
                      >
                        Recurring Frequency Unit
                      </Label>
                      <p>
                        {val?.recurringFrequencyUnit
                          ? val?.recurringFrequencyUnit
                          : "-"}
                      </p>
                    </Col>
                    <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                      <Label
                        className="fw-bold"
                        for={`balanceImpacts[${keyIndex}].cycleAlignment`}
                      >
                        Cycle Alignment
                      </Label>
                      <p>
                        {val?.cycleAlignment ? val?.cycleAlignment?.label : "-"}
                      </p>
                    </Col>
                  </>
                )}

                <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                  <Label
                    className="fw-bold"
                    for={`balanceImpacts[${keyIndex}].validityStart`}
                  >
                    Validity Starts
                  </Label>
                  <p>{val?.validityStart ? val?.validityStart?.label : "-"}</p>
                </Col>
                {val?.validityStart?.value === 3 && (
                  <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                    <Label
                      className="fw-bold"
                      for={`balanceImpacts[${keyIndex}].startDateTime`}
                    >
                      Start Date and Time
                    </Label>
                    <p>
                      {val?.startDateTime
                        ? new Date(val?.startDateTime)?.toLocaleString()
                        : "-"}
                    </p>
                  </Col>
                )}

                <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                  <Label
                    className="fw-bold"
                    for={`balanceImpacts[${keyIndex}].validityEnd`}
                  >
                    Validity Ends
                  </Label>
                  <p>{val?.validityEnd ? val?.validityEnd?.label : "-"}</p>
                </Col>

                {val?.validityEnd?.value === 3 && (
                  <>
                    <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                      <Label
                        className="fw-bold"
                        for={`balanceImpacts[${keyIndex}].timeUnit`}
                      >
                        Time Unit
                      </Label>
                      <p>{val?.timeUnit ? val?.timeUnit?.label : "-"}</p>
                    </Col>
                    <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                      <Label
                        className="fw-bold"
                        for={`balanceImpacts[${keyIndex}].timeValue`}
                      >
                        Time Value
                      </Label>
                      <p>{val?.timeValue ? val?.timeValue : "-"}</p>
                    </Col>
                  </>
                )}
                {val?.validityEnd?.value === 2 && (
                  <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                    <Label
                      className="fw-bold"
                      for={`balanceImpacts[${keyIndex}].endDateTime`}
                    >
                      End Date and Time
                    </Label>
                    <p>
                      {val?.endDateTime
                        ? new Date(val?.endDateTime)?.toLocaleString()
                        : "-"}
                    </p>
                  </Col>
                )}
                <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                  <Label
                    className="fw-bold"
                    for={`balanceImpacts[${keyIndex}].pricingModel`}
                  >
                    Pricing Model
                  </Label>
                  <p>{val?.pricingModel ? val?.pricingModel?.label : "-"}</p>
                </Col>
                {val?.pricingModel?.value === "threshold" && (
                  <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                    <Label
                      className="fw-bold"
                      for={`balanceImpacts[${keyIndex}].perUnitRate`}
                    >
                      Per Unit Rate
                    </Label>
                    <p>
                      {val?.perUnitRate?.toString() ? val?.perUnitRate : "-"}
                    </p>
                  </Col>
                )}
                <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                  <Label
                    className="fw-bold"
                    for={`balanceImpacts[${keyIndex}].chargeRule`}
                  >
                    Charge Rule
                  </Label>
                  <p>{val?.chargeRule ? val?.chargeRule?.value : "-"}</p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3} className="mb-3">
                  <Label
                    className="fw-bold"
                    for={`balanceImpacts[${keyIndex}].chargeImpact`}
                  >
                    Charge Impact
                  </Label>

                  {val?.chargeImpact?.length > 0 ? (
                    <div style={{ marginTop: "4px" }}>
                      {val?.chargeImpact
                        // chunk the array into groups of 2
                        ?.reduce((rows, item, index) => {
                          if (index % 2 === 0) rows.push([item]);
                          else rows[rows.length - 1].push(item);
                          return rows;
                        }, [])
                        .map((pair, rowIndex) => (
                          <div key={rowIndex}>
                            {pair.map((item, i) => (
                              <span key={i} style={{ marginRight: "10px" }}>
                                {item.label}
                                {i !== pair.length - 1 ||
                                rowIndex !==
                                  Math.ceil(val.chargeImpact.length / 2) - 1
                                  ? "; "
                                  : ""}
                              </span>
                            ))}
                          </div>
                        ))}
                    </div>
                  ) : (
                    <p>-</p>
                  )}
                </Col>
              </Row>

              {val?.pricingModel?.value === "volume" && (
                <ViewOfferChildTableForTier
                  row={val}
                  columns={tiersColumns}
                  tableFor="tier"
                />
              )}
            </div>
          );
        })
      )}
    </div>
  );
};

export default ViewOfferBalanceImpactList;
